import { Component, ViewChild, ElementRef, AfterViewInit, OnInit } from '@angular/core';
import { LlCompaniesService } from '../ll-companies.service';
import { LlModelsService } from '../ll-models.service';
import { LlRolesService } from '../ll-roles.service';
import { LlScrollpaneService } from '../ll-scrollpane.service';
import { LlPermissionsService } from '../ll-permissions.service';
import { jqxPanelComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxpanel'
import { jqxPopoverComponent } from "jqwidgets-scripts/jqwidgets-ts/angular_jqxpopover";
import { jqxTextAreaComponent } from "jqwidgets-scripts/jqwidgets-ts/angular_jqxtextarea";
import { fromEvent } from 'rxjs';
import { filter } from "../utility-search";
import { removeCarriageReturn } from "../utility";

@Component({
  selector: 'll-company-models_pulse-sp',
  templateUrl: './ll-company-models_pulse-sp.component.html',
  styleUrls: ['../cssMain.css']
})

export class LlCompanyModels_pulseSpComponent implements OnInit {

  @ViewChild('mainDiv_ll_company_models_pulse_sp') mainDiv: ElementRef;
  @ViewChild('vertTab_ll_company_models_pulse_sp') private vertTab: ElementRef;
  @ViewChild('scrollpane_ll_company_models_pulse_sp') private SP: jqxPanelComponent;
  @ViewChild('popover_search') private popover_search: jqxPopoverComponent;
  @ViewChild('text_search') text_search: jqxTextAreaComponent;
  @ViewChild('horzTabs_ll_company_models_pulse_sp') public horzTabs: ElementRef;
  @ViewChild('popover_ll_company_models_pulse_sp') private popover_addCo: jqxPopoverComponent;
  @ViewChild('text_name_ll_company_models_pulse_sp') text_name_ll_company_models_sp: jqxTextAreaComponent;


  constructor(
    private LlCompaniesService: LlCompaniesService,
    private LlModelsService: LlModelsService,
    private LlScrollpaneService: LlScrollpaneService,
    private LlPermissionsService: LlPermissionsService,
    private LlRolesService: LlRolesService,
  ) { }

  bundle = {
    lable: "Models",
    prefix: "CX",
    selectedId: 0,
    selectedId_ondeck: 0,
    SYSTEMROLEID:0,
    showObj: true,
    showRemaining: false,
    mode: "",
    payer_edit_mode: false,
    scrolling: false,
    canAdd: false,
    canEdit: false,
    canFilter: false,
    activeHorzTab:'',
    searchText: "",
    LlCompaniesService: this.LlCompaniesService,
    LlScrollpaneService: this.LlScrollpaneService,
    LlModelsService: this.LlModelsService,
    records: [],
    origionalRecords: [],
    INFOREQUESTSYESNO:'',
    ///groups: [],
    parentW: 0,
    parentH: 0,
    remainingX: 0,
    remainingY: 0,
    remainingW: 0,
    remainingH: 0,
    SPYPosition: 0,
    ctx: {},
    showTab: true,
    objH: 0,
    lblY: 40,
    topOffset: 0,
    spY: 0,
    spW: 175,
    MODELLENGTH:0,
    spH: 0,
    spB: 0,
    lineWidth: 1,
    vertLineX: 0,
    vertLineY: 40,
    vertLineW: 20,
    vertLineH: 0,
    tabY: 0,
    tabW: 0,
    tabH: 18,
    hTabW: 120,
    hTabH: 25,
    hTabIndent: 30,
    hTabIndx: 0,
    horzTabs: [],
    horzTabs_02: [],
    canvasHT: {},
    ctxHT: {},
  }

  ngOnInit() { }

  eventSubscription_ll_company_models_sp_mode: any;

  ngOnDestroy() {
    this.eventSubscription_ll_company_models_sp_mode.unsubscribe();
  }

  ngAfterViewInit() {

    fromEvent(this.mainDiv.nativeElement, 'mousemove')
      .subscribe(res => {
        ///setTimeout(() => {
          let value = this.SP.getVScrollPosition();

          if (value != this.bundle.SPYPosition) {
            this.bundle.SPYPosition = value;

            this.bundle.scrolling = true;

            document.getElementById(this.bundle.prefix + this.bundle.selectedId.toString()).click();
          }
        ///});
      }
      );

    fromEvent(this.mainDiv.nativeElement, 'wheel')
      .subscribe(res => {
        ///setTimeout(() => {
          let value = this.SP.getVScrollPosition();

          if (value != this.bundle.SPYPosition) {
            this.bundle.SPYPosition = value;

            this.bundle.scrolling = true;

            document.getElementById(this.bundle.prefix + this.bundle.selectedId.toString()).click();
          }
        ///});
      }
      );

    this.eventSubscription_ll_company_models_sp_mode = this.LlModelsService.ll_company_models_sp_mode.subscribe(action => {    
        this.bundle.mode = action;
    });


    this.setVars();
  }

  setVars() {

    var contactRole = this.LlRolesService.getActiveContactRole();
    this.bundle.SYSTEMROLEID = contactRole.SYSTEMROLEID;
    
    this.bundle.parentW = this.mainDiv.nativeElement.parentElement.parentElement.clientWidth;
    this.bundle.parentH = this.mainDiv.nativeElement.parentElement.parentElement.clientHeight;
    
    setTimeout(() => {
      //this.bundle.MODELLENGTH = this.LlCompaniesService.getModelLength()
      //this.bundle.spW = this.bundle.MODELLENGTH * 9;

      if (this.LlCompaniesService.getActiveCompanyId() != 0) {
        this.bundle.canAdd = this.LlPermissionsService.check("addModels");
      }

      this.LlScrollpaneService.standardDimentions(this.bundle);

      var canvasEl: HTMLCanvasElement = this.vertTab.nativeElement;
      canvasEl.width = this.bundle.vertLineX + this.bundle.vertLineW;
      canvasEl.height = this.bundle.vertLineH - 0;
      this.bundle.ctx = canvasEl.getContext('2d');

      setTimeout(() => {

        this.LlScrollpaneService.standardRemainderValues(this.bundle, canvasEl);

        var canvasHT: HTMLCanvasElement = this.horzTabs.nativeElement;
        this.bundle.canvasHT = canvasHT
        this.bundle.ctxHT = canvasHT.getContext('2d');

        this.bundle.remainingY = this.bundle.vertLineY + 10
        this.bundle.remainingH = this.bundle.vertLineH - this.bundle.remainingY;

        this.getData(this.bundle);
      });
    });
  }

  getData(bundle) {




    bundle.LlModelsService.NG_LL_company_models_get(done01, bundle);
   

    function done01(records, bundle) {

      bundle.records = records;
      bundle.origionalRecords = records;
      ///bundle.groups.splice(0);

      let selectedId_initial = bundle.LlModelsService.getActiveId();

      setTimeout(() => {

        bundle.showObj = true;

        setTimeout(() => {

          if (selectedId_initial != null && document.getElementById(bundle.prefix + selectedId_initial.toString()) != null) {
            document.getElementById(bundle.prefix + selectedId_initial.toString()).click();
          }

        });
      });
    }
  }

  select(event) {

    this.bundle = this.LlScrollpaneService.bundle(event, this.bundle, this.SP)

    this.LlScrollpaneService.paintVertTab(this.bundle);

    if (this.bundle.scrolling == true) {

      this.bundle.scrolling = false;

    } else {

      this.bundle.showRemaining = false;

      setTimeout(() => {

        this.bundle.selectedId = this.bundle.selectedId_ondeck;

        this.LlModelsService.setActiveId(this.bundle.selectedId, "ll_company_models_sp");

        this.LlModelsService.getActiveLoanModel(done01, this.bundle)

        function done01(model, bundle) {

          ///console.log("model.INFOREQUESTSYESNO: " + model.INFOREQUESTSYESNO)

          bundle.horzTabs.splice(0);

          if (model.INFOREQUESTSYESNO == 'Yes'){
            bundle.horzTabs.push({ lbl: "Info. Reqsts" });
          }
          
          bundle.LlScrollpaneService.paintHorzTab(horzTabSelected, bundle.horzTabs, bundle.canvasHT, bundle.ctxHT, bundle, false);

         
          if (bundle.activeHorzTab == '') {
            bundle.activeHorzTab = bundle.horzTabs[0].lbl;
          }

          //bundle.activeHorzTab = bundle.horzTabs[0].lbl;

          function horzTabSelected(indx, bundle) {
            //bundle.mode = ''; ///clear the mode parameter
            //bundle.activeHorzTab = bundle.horzTabs[indx].lbl;
          }

          bundle.showRemaining = true;
        }
       
      });
    }
  }

  noAction() {
    //needed HTML buttons point to this
  }

  onKeyUp(event) {

    if (event.keyCode == 13) { ///Enter
      this.text_search.val(removeCarriageReturn(this.text_search.val()));
      this.search();
    }

    if (event.keyCode == 9) { ///Tab || Enter
      this.search();
    }
  }

  search() {

    this.popover_search.close()

    setTimeout(() => {
      this.bundle.searchText = this.text_search.val();

      if (this.bundle.searchText == "") {
        this.bundle.records = this.bundle.origionalRecords;
      } else {
        this.bundle.records = filter(this.bundle.origionalRecords, "FOLDERNAME", this.bundle.searchText);

        if (this.bundle.records.length > 0) {
          this.bundle.selectedId = this.bundle.records[0].FOLDERID;

          //this.LlCompaniesService.setActive(this.bundle.selectedId);

        }
      }

      this.searchClick();
    });
  }

  clear() {
    this.bundle.records = this.bundle.origionalRecords;

    ///console.log(this.bundle.records)

    this.bundle.searchText = ""
    this.text_search.val("");
    let looking = true;

    for (var i = 0; i < this.bundle.records.length; i++) {

      if (this.bundle.records[i].FOLDERID > 0 && looking == true) {

        looking = false;

        this.popover_search.close()

        this.bundle.selectedId = this.bundle.records[i].FOLDERID;

        ///this.LlCompaniesService.setActive(this.bundle.selectedId);

        setTimeout(() => {

          //console.log("this.bundle.selectedId: " + this.bundle.selectedId)

          if (this.bundle.selectedId != null && document.getElementById(this.bundle.prefix + this.bundle.selectedId.toString()) != null) {
            document.getElementById(this.bundle.prefix + this.bundle.selectedId.toString()).click();
          }
        }, 200);
      }
    }
  }

  searchClick() {


    if (this.bundle.records.length == 0) {

      this.bundle.showTab = false;
      this.bundle.selectedId = -666

      this.LlScrollpaneService.paintVertTab(this.bundle);

    } else {

      let selectedId_local = this.bundle.records[0].FOLDERID;

      setTimeout(() => {

        if (selectedId_local != null && document.getElementById(this.bundle.prefix + selectedId_local.toString()) != null) {

          document.getElementById(this.bundle.prefix + selectedId_local.toString()).click();
        }

      });
    }

  }

  add() {

    if (this.text_name_ll_company_models_sp.val() != "") {

      this.popover_addCo.close();

      this.LlModelsService.NG_LL_company_model_add(this.text_name_ll_company_models_sp.val(), this.getData, this.bundle);

    }
  }

  clearMode() {
    this.bundle.mode = '';
  }

 
}

